import 'primeflex/primeflex.css';
import 'primeflex/primeflex.min.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/soho-light/theme.css'

import React               from 'react';
import {Route, Routes}     from "react-router-dom";
import {addLocale, locale} from 'primereact/api';

import Context       from "./services/context";
import {portugues}   from "./configs/utils";
import Login         from "./pages/login";
import ResetarSenha  from "./pages/resetar-senha";
import EsqueciSenha  from "./pages/esqueci-senha";
import Sistema       from "./pages/sistema";
import Participante  from "./pages/participante";
import Evento        from "./pages/evento";
import Categoria     from "./pages/categoria";
import Usuario       from "./pages/usuario";
import Cliente       from "./pages/cliente";
import Especialidade from "./pages/especialidade";
import Relatorio     from "./pages/relatorio";

export default function App() {
    addLocale('pt-BR', portugues);
    locale('pt-BR');

    return (
        <Context.Provider value={[false, () => {
        }]}>
            <Routes>
                <Route path="/" element={<Login/>}/>
                <Route path="/resetar-senha" element={<ResetarSenha/>}/>
                <Route path="/esqueci-senha" element={<EsqueciSenha/>}/>
                <Route path="/sistema" element={<Sistema/>}/>
                <Route path="/participante" element={<Participante/>}/>
                <Route path="/evento" element={<Evento/>}/>
                <Route path="/categoria" element={<Categoria/>}/>
                <Route path="/especialidade" element={<Especialidade/>}/>
                <Route path="/usuario" element={<Usuario/>}/>
                <Route path="/cliente" element={<Cliente/>}/>
                <Route path="/relatorio" element={<Relatorio/>}/>
            </Routes>
        </Context.Provider>
    );
}
